import { TypographyHeading } from "shared/molecules/typography-layout";
import { Box, InputLabel, Paper, FormControl, Select, MenuItem, Pagination, Stack } from "@mui/material";
import Loader from "pages/build-test/loader";
import { useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import NoDataFound from "shared/molecules/no-data";
import { table } from "./helper"
import liveClassClientService from "utils/graphql/liveclassClient";
import { GET_EMPLOYEE_DESIGNATIONS } from "utils/graphql/services/live-classes/queries";
import { EmployeeDesignationsFilter } from "./filter";
import CollapsibleTable from "shared/organisms/tables/collapsible-table";
import { utcToIst } from "utils/time-util/utcIstTime";
import authClientService from "utils/graphql/authClient";

export default function EmployeeDesignations() {
    const [searchPayload, setSearchPayload] = useState({});
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [clearValuesTrigger, setClearValuesTrigger] = useState(0);

    const [getDesignationsList, { loading, error, data }] = useLazyQuery(
        GET_EMPLOYEE_DESIGNATIONS,
        {
            client: authClientService,
        },
    );

    useEffect(() => {
        getDesignationsList({
            variables: {
                input: {
                    limit: limit,
                    offset: (page - 1) * limit,
                    ...searchPayload,
                },
            },
        });
    }, [page, limit, searchPayload]);

     const empDesgData =
                    data?.getEmployeeDesignations?.employeeDesignations?.map((item: any) => ({
                        ...item,
                        createdAt: utcToIst(item.createdAt),
                        updatedAt: utcToIst(item.updatedAt),
                    })) || [];
    return (
        <>
            <TypographyHeading sx={{ mb: 2, mt: 3, fontSize: "25px" }}>
                Employee Designations
            </TypographyHeading>

            <EmployeeDesignationsFilter
                setSearchPayload={setSearchPayload}
                setPage={setPage}
                clearValuesTrigger={clearValuesTrigger}
            />

            <Paper elevation={2} sx={{ p: 2, mt: 3 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                    <FormControl size="small" sx={{ width: 140 }}>
                        <InputLabel>Show Entries</InputLabel>
                        <Select
                            value={limit}
                            label="Show Entries"
                            onChange={(e) => {
                                setLimit(Number(e.target.value));
                                setPage(1);
                            }}
                        >
                            <MenuItem value={5}>5</MenuItem>
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                            <MenuItem value={500}>500</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                <div>
                    {loading && <Loader />}
                    {!loading && data?.getEmployeeDesignations?.employeeDesignations?.length > 0 ? (
                        <CollapsibleTable
                            data={empDesgData|| []}
                            table={table}
                            id="id"
                            name="id"
                            rowsPerPageCount={limit}
                            style="false"
                            totalRecords={data?.getEmployeeDesignations?.totalCount || 0}
                            paginationSegmentApi="false"
                            viewSecondaryData="false"
                            showPaginationFooter={false}
                        />
                    ) : (
                        <div>{!loading && <NoDataFound message="No Data Found" />}</div>
                    )}
                </div>

                <Box sx={{ marginTop: "20px" }}>
                    <Stack direction="row" spacing={2} justifyContent="center" alignItems="center">
                        <Pagination
                            count={Math.ceil(data?.getEmployeeDesignations?.totalCount / limit) || 1}
                            page={page}
                            onChange={(e, value) => setPage(value)}
                            color="primary"
                            size="medium"
                        />
                    </Stack>
                </Box>
            </Paper>
        </>
    )
}
